$('ul').sortable();

var stepsTotal = 6;
var username;
var step2answer = [];
var step3answer = [];
var completeData = [];
var experienceLevel;
var userAgeGroup;
var feedback= [];
var interests = [];
var usermail;
var recommendations = [];

// STEP 1
$('div[data-step="1"] input').on('input', function() {
  if( $('#pure-builder-username').val().length > 0 /*&& isEmail($('#pure-builder-usermail').val()) == true*/ ){
    $('div[data-step="1"] button').prop("disabled", false);
  } else {
    $('div[data-step="1"] button').prop("disabled", true);
  }
});
$('div[data-step="1"] button').click( function(){
  username = $('#pure-builder-username').val();
  usermail = $('#pure-builder-usermail').val();
  $('div[data-step="2"] .pure-builder-content h3 name').html(username);
  $('div[data-step="1"], div[data-step="2"]').toggleClass('active');
  $('.processline').css('height',(2/stepsTotal*100)+'%');
  //$("html,body").animate({scrollTop:0}, '500');
});

// STEP 2
$('div[data-step="2"] .pure-builder__form label').click( function(){
  if( $('div[data-step="2"] .pure-builder__form input:checked').length == 0 ){
    $('div[data-step="2"] button').prop("disabled", true);
  } else {
    $('div[data-step="2"] button').prop("disabled", false);
  }

  /*if( $('div[data-step="2"] .pure-builder__form input:checked').length >= 2 ){
    $('div[data-step="2"] .pure-builder__form input').not(':checked').prop('disabled', true);
  } else {
    $('div[data-step="2"] .pure-builder__form input').prop('disabled', false);
  }*/

});
$('div[data-step="2"] button[data-action="go"]').click( function (){
  step2answer = [];
  $('div[data-step="3"] .pure-builder__form').find('div').css('display','none');
  $('div[data-step="4"] .pure-builder__form').find('div').css('display','none');
  $('div[data-step="2"] .pure-builder__form label').find('input').each( function(){
    if( $(this).is(':checked') ){
      step2answer.push( $(this).val() );
      $('div[data-step="3"]').find('div[data-topic="'+$(this).val()+'"]').css('display','block');
      $('div[data-step="4"]').find('div[data-topic="'+$(this).val()+'"]').css('display','block');
    }
  })
  //console.log(step2answer);
  $('div[data-step="2"], div[data-step="3"]').toggleClass('active');
  $('.processline').css('height',(3/stepsTotal*100)+'%');
  //$("html,body").animate({scrollTop:0}, '500');
});
$('div[data-step="2"] button[data-action="back"]').click( function (){
  $('div[data-step="1"], div[data-step="2"]').toggleClass('active');
  $('.processline').css('height',(1/stepsTotal*100)+'%');
  //$("html,body").animate({scrollTop:0}, '500');
});

// STEP 3
$('div[data-step="3"] .pure-builder__form label').click( function(){
  if( $('div[data-step="3"] .pure-builder__form input:checked').length == 0 ){
    $('div[data-step="3"] button').prop("disabled", true);
  } else {
    $('div[data-step="3"] button').prop("disabled", false);
  }

  if( $('div[data-step="3"] .pure-builder__form input:checked').length >= 6 ){
    $('div[data-step="3"] .pure-builder__form input').not(':checked').prop('disabled', true);
  } else {
    $('div[data-step="3"] .pure-builder__form input').prop('disabled', false);
  }

});
$('div[data-step="3"] button[data-action="go"]').click( function (){
  step3answer = [];
  $('div[data-step="4"]').find('label').css('display','none');
  $('div[data-step="3"] .pure-builder__form label').find('input').each( function(){
    if( $(this).is(':checked') ){
      step3answer.push( $(this).val() );
      $('div[data-step="4"]').find('#'+$(this).val()).css('display','flex');
    }
  })
  //console.log(step3answer);
  // JUMPER START
  $('div[data-step="5"]').find('li').css('display','none');
  $('div[data-step="5"]').find('li').addClass('hidden');
  for (let i = 0; i < step3answer.length; i++) {
    $('div[data-step="5"]').find('#'+step3answer[i]).css('display','flex');
    $('div[data-step="5"]').find('#'+step3answer[i]).removeClass('hidden');
    $('div[data-step="5"]').find('#'+step3answer[i]).attr('data-severity', $('div[data-step="4"] #'+step3answer[i]+' input').val());
  }
  // JUMPER END
  $('div[data-step="3"], div[data-step="5"]').toggleClass('active');
  $('.processline').css('height',(4/stepsTotal*100)+'%');
  //$("html,body").animate({scrollTop:0}, '500');
});
$('div[data-step="3"] button[data-action="back"]').click( function (){
  $('div[data-step="3"] .pure-builder__form label').find('input').prop( "checked", false );
  $('div[data-step="2"], div[data-step="3"]').toggleClass('active');
  $('.processline').css('height',(2/stepsTotal*100)+'%');
  //$("html,body").animate({scrollTop:0}, '500');
});

// STEP 4
$('div[data-step="4"] button[data-action="go"]').click( function (){
  $('div[data-step="5"]').find('li').css('display','none');
  $('div[data-step="5"]').find('li').addClass('hidden');
  for (let i = 0; i < step3answer.length; i++) {
    $('div[data-step="5"]').find('#'+step3answer[i]).css('display','flex');
    $('div[data-step="5"]').find('#'+step3answer[i]).removeClass('hidden');
    $('div[data-step="5"]').find('#'+step3answer[i]).attr('data-severity', $('div[data-step="4"] #'+step3answer[i]+' input').val());
  }
  $('div[data-step="4"], div[data-step="5"]').toggleClass('active');
  $('.processline').css('height',(5/stepsTotal*100)+'%');
  //$("html,body").animate({scrollTop:0}, '500');
});
$('div[data-step="4"] button[data-action="back"]').click( function (){
  $('div[data-step="3"], div[data-step="4"]').toggleClass('active');
  $('.processline').css('height',(3/stepsTotal*100)+'%');
  //$("html,body").animate({scrollTop:0}, '500');
});

// STEP 5
$('div[data-step="5"] button[data-action="go"]').click( function (){
  completeData= [];
  interests = [];
  $('div[data-step="5"] li').not('.hidden').each( function(index){
    completeData.push( {
      interest: $(this).attr('id'),
      severity:  $(this).attr('data-severity'),
      order: index+1
    });
    interests.push( $(this).text().trim() );
  })
  $('div[data-step="5"], div[data-step="6"]').toggleClass('active');
  $('.processline').css('height',(5/stepsTotal*100)+'%');
  //$("html,body").animate({scrollTop:0}, '500');
  //console.log(completeData)
});
$('div[data-step="5"] button[data-action="back"]').click( function (){
  $('div[data-step="5"], div[data-step="3"]').toggleClass('active');
  $('.processline').css('height',(3/stepsTotal*100)+'%');
  //$("html,body").animate({scrollTop:0}, '500');
});

// STEP 6
$('div[data-step="6"] button[data-action="go"]').click( function (){
  experienceLevel = $('div[data-step="6"] input').val();
  $('div[data-step="6"], div[data-step="7"]').toggleClass('active');
  $('.processline').css('height',(6/stepsTotal*100)+'%');
  //$("html,body").animate({scrollTop:0}, '500');
});
$('div[data-step="6"] button[data-action="back"]').click( function (){
  $('div[data-step="5"], div[data-step="6"]').toggleClass('active');
  $('.processline').css('height',(4/stepsTotal*100)+'%');
  //$("html,body").animate({scrollTop:0}, '500');
});

// STEP 7
$('div[data-step="7"] .pure-builder__form label').click( function(){
  $('div[data-step="7"] button').prop("disabled", false);
  $(this).find('input').each( function(){
    if( $(this).is(':checked') ){
      userAgeGroup = $(this).val();
    }
  })
});
/*$('div[data-step="7"] button[data-action="go"]').click( function (){
  $('div[data-step="7"], div[data-step="8"]').toggleClass('active');
  $('.processline').css('height',(8/stepsTotal*100)+'%');
  $("html,body").animate({scrollTop:0}, '500');
});*/
$('div[data-step="7"] button[data-action="back"]').click( function (){
  $('div[data-step="6"], div[data-step="7"]').toggleClass('active');
  $('.processline').css('height',(5/stepsTotal*100)+'%');
  //$("html,body").animate({scrollTop:0}, '500');
});

// STEP 8
$('div[data-step="7"] button[data-action="go"]').click( function (){
  feedback= [];
  $('div[data-step="8"] li').each( function(index){
    feedback.push( {
      topic: $(this).attr('id'),
      order: index+1
    });
  })
  $('div[data-step="final"] .pure-builder-content h3').prepend(username);

  $('.pure-overview div').css('display','none');
  for (let i = 0; i < completeData.length; ++i) {
      if( completeData[i].interest == 'sport-1'){
        recommendations.push('Q10');
        recommendations.push('Vitamin C');
      }
      if( completeData[i].interest == 'sport-2'){
        recommendations.push('Tryptophan');
        recommendations.push('Melatonin');
      }
      if( completeData[i].interest == 'sport-3'){
        recommendations.push('OPC');
        recommendations.push('Eisen');
        recommendations.push('Curcuma');
      }
      if( completeData[i].interest == 'sport-4'){
        recommendations.push('Q10');
        recommendations.push('Vitamin B12');
      }
      if( completeData[i].interest == 'beauty-1'){
        recommendations.push('Q10');
        recommendations.push('OPC');
        recommendations.push('Astaxanthin');
      }
      if( completeData[i].interest == 'beauty-2'){
        recommendations.push('Q10');
      }
      if( completeData[i].interest == 'beauty-3'){
        recommendations.push('Q10');
        recommendations.push('Curcuma');
      }
      if( completeData[i].interest == 'beauty-4'){
        recommendations.push('Vitamin C');
        recommendations.push('Eisen');
      }
      if( completeData[i].interest == 'immun-1'){
        recommendations.push('Vitamin C');
        recommendations.push('Vitamin D3 K2');
      }
      if( completeData[i].interest == 'immun-2'){
        recommendations.push('Astaxanthin');
        recommendations.push('OPC');
      }
      if( completeData[i].interest == 'immun-3'){
        recommendations.push('Astaxanthin');
        recommendations.push('Omega 3');
        recommendations.push('Vitamin D3 K2');
      }
      if( completeData[i].interest == 'immun-4'){
        recommendations.push('Curcuma');
        recommendations.push('Vitamin C');
      }
      if( completeData[i].interest == 'sleep-1'){
        recommendations.push('Melatonin');
        recommendations.push('Tryptophan');
      }
      if( completeData[i].interest == 'sleep-2'){
        recommendations.push('Melatonin');
        recommendations.push('Vitamin D3 K2');
      }
      if( completeData[i].interest == 'sleep-3'){
        recommendations.push('Tryptophan');
        recommendations.push('Vitamin D3 K2');
      }
      if( completeData[i].interest == 'well-1'){
        recommendations.push('Eisen');
        recommendations.push('Tryptophan');
      }
      if( completeData[i].interest == 'well-2'){
        recommendations.push('OPC');
        recommendations.push('Omega 3');
        recommendations.push('Q10');
      }
      if( completeData[i].interest == 'well-3'){
        recommendations.push('Tryptophan');
        recommendations.push('Melatonin');
      }
      if( completeData[i].interest == 'well-4'){
        recommendations.push('Vitamin B12');
        recommendations.push('Eisen');
        recommendations.push('Vitamin D3 K2');
      }
      if( completeData[i].interest == 'well-5'){
        recommendations.push('Omega 3');
        recommendations.push('OPC');
      }
  }

  var cleanedRecommendations = unique(recommendations).slice(0,6);

  for (let c = 0; c < cleanedRecommendations.length; ++c) {
    if( cleanedRecommendations[c] == 'Q10'){
        $('.pure-overview div[data-product="LV-Q10-10"]').css({'display':'block','order':c+1});
        $('div[data-product="LV-Q10-10"] input').prop( "checked", true );
    }
    if( cleanedRecommendations[c] == 'OPC'){
        $('.pure-overview div[data-product="LV-OPC-10"]').css({'display':'block','order':c+1});
        $('div[data-product="LV-OPC-10"] input').prop( "checked", true );
    }
    if( cleanedRecommendations[c] == 'Vitamin B12'){
        $('.pure-overview div[data-product="LV-B12-10"]').css({'display':'block','order':c+1});
        $('div[data-product="LV-B12-10"] input').prop( "checked", true );
    }
    if( cleanedRecommendations[c] == 'Melatonin'){
        $('.pure-overview div[data-product="LV-MELA-10"]').css({'display':'block','order':c+1});
        $('div[data-product="LV-MELA-10"] input').prop( "checked", true );
    }
    if( cleanedRecommendations[c] == 'Tryptophan'){
        $('.pure-overview div[data-product="LV-TRYP-10"]').css({'display':'block','order':c+1});
        $('div[data-product="LV-TRYP-10"] input').prop( "checked", true );
    }
    if( cleanedRecommendations[c] == 'Astaxanthin'){
        $('.pure-overview div[data-product="LV-ASTA-10"]').css({'display':'block','order':c+1});
        $('div[data-product="LV-ASTA-10"] input').prop( "checked", true );
    }
    if( cleanedRecommendations[c] == 'Omega 3'){
        $('.pure-overview div[data-product="LV-OMEGA3-10"]').css({'display':'block','order':c+1});
        $('div[data-product="LV-OMEGA3-10"] input').prop( "checked", true );
    }
    if( cleanedRecommendations[c] == 'Vitamin D3 K2'){
        $('.pure-overview div[data-product="LV-D3K2-10"]').css({'display':'block','order':c+1});
        $('div[data-product="LV-D3K2-10"] input').prop( "checked", true );
    }
    if( cleanedRecommendations[c] == 'Curcuma'){
        $('.pure-overview div[data-product="LV-CURCUMA-10"]').css({'display':'block','order':c+1});
        $('div[data-product="LV-CURCUMA-10"] input').prop( "checked", true );
    }
    if( cleanedRecommendations[c] == 'Vitamin C'){
        $('.pure-overview div[data-product="LV-VITC-10"]').css({'display':'block','order':c+1});
        $('div[data-product="LV-VITC-10"] input').prop( "checked", true );
    }
    if( cleanedRecommendations[c] == 'Eisen'){
        $('.pure-overview div[data-product="LV-IRON-10"]').css({'display':'block','order':c+1});
        $('div[data-product="LV-IRON-10"] input').prop( "checked", true );
    }
  }
  
  $('#fullsetpromo').css('display','block');
  $('div[data-step="7"], div[data-step="final"]').toggleClass('active');
  $('.pure-builder-processbar').css('display','none');
  //$("html,body").animate({scrollTop:0}, '500');
  
  $('#build-with-pure-builder').val(username);
  //formv3('25092832','72355b97-5a9b-412c-8296-27012681614c',usermail,username,step2answer.join(),interests.join(),experienceLevel,userAgeGroup);
  toSpreadsheet(username,step2answer.join(),interests.join().trim(),experienceLevel,userAgeGroup,cleanedRecommendations.join());

  // PRINT SAVED DATA
  /*$('#resultData').html('');
  $('#resultData').append('<p><b>Produktinteresse: </b>'+JSON.stringify(completeData)+'</p>');
  $('#resultData').append('<p><b>Erfahrung: </b>'+JSON.stringify(experienceLevel)+'</p>');
  $('#resultData').append('<p><b>Altersgruppe: </b>'+JSON.stringify(userAgeGroup)+'</p>');
  $('#resultData').append('<p><b>Feedback: </b>'+JSON.stringify(feedback)+'</p>');*/
});
/*$('div[data-step="8"] button[data-action="back"]').click( function (){
  $('div[data-step="7"], div[data-step="8"]').toggleClass('active');
  $('.processline').css('height',(7/stepsTotal*100)+'%');
  $("html,body").animate({scrollTop:0}, '500');
});*/

// PRODUCT HANDLING

$('.pure-products label').click( function(){
  if( $('.pure-products input:checked').length == 0 ){
    $('.pure-products input[type="submit"]').prop("disabled", true);
  } else {
    $('.pure-products input[type="submit"]').prop("disabled", false);
  }
  
  /*if( $('.pure-products input:checked').length == $('.pure-products input:visible').length-1 ){
    $('#fullsetpromo').css('display','block');
  } else {
    $('#fullsetpromo').css('display','none');
  }*/
});

// SEND TO SPREADSHEET 
function toSpreadsheet(name, topics, interests, experience, age, products){

  const scriptURL = 'https://script.google.com/macros/s/AKfycby58TD03Q2zG8E8IKAiS24gmwKsskMbrg0W0rP3KIgCVWFnH5GJoBVM4PhHdvgvdAKb3A/exec'
  $('.pure-builder-container').append( '<form style="display:none" name="pure-builder-script"><input type="text" name="firstname" value="'+name+'"><input type="text" name="themengebiete" value="'+topics+'"><input type="text" name="einzelne_interessen" value="'+interests+'"><input type="text" name="erfahrungen" value="'+experience+'"><input type="text" name="altersgruppe" value="'+age+'"><input type="text" name="produktempfehlungen" value="'+products+'"></form>' );
  const form = document.forms['pure-builder-script'];
  fetch(scriptURL, { method: 'POST', body: new FormData(form)})
  .then(response => console.log("You have successfully submitted."))
  .catch(error => console.error('Error!', error.message))
}

// SEND TO HUBSPOT FUNCTION
function formv3(portalid, formid, mail, name, topics, interests, experience, age){
  var xhr = new XMLHttpRequest();
  var url = 'https://api.hsforms.com/submissions/v3/integration/submit/' + portalid + '/' + formid + '';

  var data = {
    "fields": [
      {
        "name": "email",
        "value": mail
      },
      {
        "name": "firstname",
        "value": name
      },
      {
        "name": "themengebiete",
        "value": topics
      },
      {
        "name": "einzelne_interessen",
        "value": interests
      },
      {
        "name": "erfahrungen",
        "value": experience
      },
      {
        "name": "altersgruppe",
        "value": age
      }
    ]
  }

  var final_data = JSON.stringify(data)

  xhr.open('POST', url);
  xhr.setRequestHeader('Content-Type', 'application/json');

  xhr.onreadystatechange = function() {
    if(xhr.readyState == 4 && xhr.status == 200) { 
      console.log(xhr.responseText); // Returns a 200 response if the submission is successful.
    } else if (xhr.readyState == 4 && xhr.status == 400){ 
      console.log(xhr.responseText); // Returns a 400 error the submission is rejected.          
    } else if (xhr.readyState == 4 && xhr.status == 403){ 
      console.log(xhr.responseText); // Returns a 403 error if the portal isn't allowed to post submissions.           
    } else if (xhr.readyState == 4 && xhr.status == 404){ 
      console.log(xhr.responseText); //Returns a 404 error if the formGuid isn't found     
    }
  }

  xhr.send(final_data)
}

// VALIDATE MAIL FUNCTION
function isEmail(email) {
  var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return regex.test(email);
}

// remove duplicates from an array of strings
function unique(list) {
    var result = [];
    $.each(list, function(i, e) {
        if ($.inArray(e, result) == -1) result.push(e);
    });
    return result;
}